// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Skeleton_crypt__gm\\+d2 {
    opacity: 0.7;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.Skeleton_skeleton__TU\\+V0 {
    background-color: var(--color-lightui-accent-2);
    border-radius: 4px;
    animation: Skeleton_loading__NQphY 1s infinite ease-in-out;
}

.Skeleton_circle__Me\\+vl {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    min-height: 8px;
}

.Skeleton_container__qidQ5 {
    width: 100%;
    height: 100%;
}

.Skeleton_title__uemBF {
    width: 100%;
    min-height: 32px;
}

.Skeleton_text__HzTKM {
    width: 100%;
    min-height: 14px;
}

.Skeleton_subText__DChdw {
    width: 100%;
    min-height: 12px;
}

@keyframes Skeleton_loading__NQphY {
    0% {
        background-color: var(--color-lightui-accent-2);
    }
    50% {
        background-color: var(--color-138);
    }
    100% {
        background-color: var(--color-lightui-accent-2);
    }
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Skeleton/Skeleton.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,0DAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,+CAA+C;IACnD;IACA;QACI,kCAAkC;IACtC;IACA;QACI,+CAA+C;IACnD;AACJ","sourcesContent":[".crypt {\n    opacity: 0.7;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.skeleton {\n    background-color: var(--color-lightui-accent-2);\n    border-radius: 4px;\n    animation: loading 1s infinite ease-in-out;\n}\n\n.circle {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    min-height: 8px;\n}\n\n.container {\n    width: 100%;\n    height: 100%;\n}\n\n.title {\n    width: 100%;\n    min-height: 32px;\n}\n\n.text {\n    width: 100%;\n    min-height: 14px;\n}\n\n.subText {\n    width: 100%;\n    min-height: 12px;\n}\n\n@keyframes loading {\n    0% {\n        background-color: var(--color-lightui-accent-2);\n    }\n    50% {\n        background-color: var(--color-138);\n    }\n    100% {\n        background-color: var(--color-lightui-accent-2);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"crypt": `Skeleton_crypt__gm+d2`,
	"skeleton": `Skeleton_skeleton__TU+V0`,
	"loading": `Skeleton_loading__NQphY`,
	"circle": `Skeleton_circle__Me+vl`,
	"container": `Skeleton_container__qidQ5`,
	"title": `Skeleton_title__uemBF`,
	"text": `Skeleton_text__HzTKM`,
	"subText": `Skeleton_subText__DChdw`
};
export default ___CSS_LOADER_EXPORT___;
